var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValue2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Value_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Value_1",
    "data-name": "Value \\u2013 1",
    clipPath: "url(#clip-Value_1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12212",
    "data-name": "Group 12212",
    transform: "translate(-1259 -10710)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_12208",
    "data-name": "Group 12208",
    transform: "translate(224.755 10758.199)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_308",
    "data-name": "Group 308",
    transform: "translate(1056 -29)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12995",
    "data-name": "Path 12995",
    d: "M1126.8,469.239l-18.19,22.523-18.191-22.533c2.8-2.6,5.51-5.161,8.287-7.646a2.682,2.682,0,0,1,1.654-.439q8.22-.047,16.439,0a2.936,2.936,0,0,1,1.809.515C1121.339,464.1,1124,466.633,1126.8,469.239Zm-18.442,14.853.446-.018,3.6-13.406h-7.669C1105.965,475.244,1107.159,479.668,1108.354,484.092Zm3.12-.386.3.163,10.712-13.3c-2.438,0-4.366-.051-6.287.036-.472.022-1.23.4-1.337.773C1113.672,475.472,1112.586,479.593,1111.473,483.707Zm-6.144.021.3-.138c-1.081-3.992-2.142-7.99-3.273-11.969-.116-.406-.628-.978-.979-.994-2.073-.094-4.152-.046-6.666-.046Zm-9.564-15.766c6.148.563,8.245-.38,9.622-4.126C1101.158,462.546,1098.248,464.564,1095.765,467.962Zm25.917.117c-3.947-4.415-5.709-5.155-9.619-4.149.766,1.18,1.471,2.349,2.27,3.448a1.71,1.71,0,0,0,1.131.67C1117.414,468.116,1119.368,468.079,1121.682,468.079Zm-9.983-.1-2.707-4.141-3.338,4.141Z",
    transform: "translate(-1090.415 -450.161)",
    fill: "#f9f9fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12996",
    "data-name": "Path 12996",
    d: "M1137.546,436.86a4.94,4.94,0,0,0-5.924.092c1.144-2.013,1.617-3.946-.487-6.138a15.228,15.228,0,0,0,3.455.979,12.419,12.419,0,0,0,3.118-.892C1136.373,432.924,1136.078,434.858,1137.546,436.86Z",
    transform: "translate(-1116.41 -430.814)",
    fill: "#f9f9fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12997",
    "data-name": "Path 12997",
    d: "M1180.512,439.261a4.866,4.866,0,0,0,.089,6.007c-2.035-1.166-3.989-1.424-6.064.057,1.262-2.042,1.508-3.984-.01-6.054A5.27,5.27,0,0,0,1180.512,439.261Z",
    transform: "translate(-1144.112 -436.206)",
    fill: "#f9f9fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12998",
    "data-name": "Path 12998",
    d: "M1098.7,446.164a5.013,5.013,0,0,0-6,.057c1.283-2.052,1.5-3.987-.057-6.048,2.051,1.122,4,1.373,6.077-.067C1097.422,442.179,1097.229,444.111,1098.7,446.164Z",
    transform: "translate(-1091.839 -436.746)",
    fill: "#f9f9fd"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValue2);
export default __webpack_public_path__ + "static/media/value-2.3cc39e3c9d73ee5cc46f1f09837311be.svg";
export { ForwardRef as ReactComponent };